<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '30vw', position: 'relative' }"
      :header="'Associar Técnico ao Ticket'"
      :modal="true"
      :closable="false"
    >
      <form
        name="HelpdeskTicketsChangeResponsible"
        class="p-col-12"
        @submit.prevent="saveNewTechnician"
        style="min-height: 15vh"
      >
        <Loading
          :active.sync="showLoader"
          :isFullPage="false"
          :zIndex="9000"
        ></Loading>
        <p v-if="!selected">
          <b>Ticket {{ ticketId }} | {{ ticketSubject }}</b>
        </p>
        <p v-else v-for="ticketSelected in selected" :key="ticketSelected.id">
          <b>Ticket {{ ticketSelected.id }} | {{ ticketSelected.subject }}</b>
        </p>
        <div class="p-fluid p-formgrid p-grid" style="min-height: 50vh">
          <div class="p-field p-col-12 p-md-12 p-mt-4">
            <span class="p-float-label">
              <Dropdown
                name="responsibleUser"
                :options="listEmployees"
                :filter="true"
                :optionLabel="employeeLabel"
                :optionValue="'technician_id'"
                v-model="current"
                v-validate="'required'"
                v-bind:class="[
                  { 'p-invalid': errors.has('responsibleUser') },
                  'form-control',
                ]"
              >
              </Dropdown>
              <label for="responsibleUser"
                >Selecionar Técnico Responsável pelo Ticket</label
              >
            </span>
            <small
              v-if="errors.has('responsibleUser')"
              class="p-error"
              role="alert"
            >
              Funcionário é obrigatório
            </small>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-check"
          class="p-button-success"
          @click="saveNewTechnician"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import ticketService from "../../services/tickets.service";
import employeeService from "../../services/employee.service";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "ChangeResponsible",
  components: {
    Loading,
  },
  props: [
    "showToast",
    "show",
    "currentTechnician",
    "ticketId",
    "ticketSubject",
    "selected",
  ],
  watch: {
    currentTechnician() {
      this.showLoader = false;
      this.$validator.pause();
      this.$validator.reset();
      this.current = !this.selected ? this.currentTechnician : null;
    },
  },
  data() {
    return {
      current: !this.selected ? this.currentTechnician : null,
      listEmployees: [],
      showLoader: false,
    };
  },
  created() {
    this.getActiveEmployees();
  },
  methods: {
    getActiveEmployees() {
      return employeeService
        .getActives()
        .then((response) => (this.listEmployees = response));
    },
    cancel() {
      return this.$emit("cancel");
    },
    saveNewTechnician() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.$validator.pause();
        this.$validator.reset();
        if (this.selected != null) {
          return this.setResponsabilityMultipleTickets();
        }
        this.showLoader = true;
        return ticketService
          .setAssigned(this.ticketId, { technician_id: parseInt(this.current) })
          .then((response) => {
            this.showLoader = false;
            if (!response) {
              if (this.showToast) {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro ao alterar o responsável pelo ticket",
                  detail: "",
                  life: 3000,
                });
              }
              return this.$emit("changeTechnicianResp", {
                status: "error",
                currenTechnican: null,
              });
            }

            if (this.showToast) {
              this.$toast.add({
                severity: "success",
                summary: `Responsável pelo ticket alterado com sucesso`,
                detail: ``,
                life: 3000,
              });
            }
            return this.$emit("changeTechnicianResp", {
              status: "ok",
              result: response,
            });
          });
      });
    },
    employeeLabel(info) {
      return `${info.username} | ${info.department}`;
    },
    async setResponsabilityMultipleTickets() {
      let noErrors = true;
      let res = null;
      this.showLoader = true;
      for (const ticket of this.selected) {
        await ticketService
          .setAssigned(ticket.id, { technician_id: parseInt(this.current) })
          .then((response) => {
            if (!response) {
              return (noErrors = false);
            }
            res = response;
          });
      }
      this.showLoader = false;
      if (!noErrors) {
        if (this.showToast) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao alterar o responsável pelo ticket",
            detail: "",
            life: 3000,
          });
        }
        return this.$emit("changeTechnicianResp", {
          status: "error",
          currenTechnican: null,
        });
      }
      if (this.showToast) {
        this.$toast.add({
          severity: "success",
          summary: `Responsável pelo ticket alterado com sucesso`,
          detail: ``,
          life: 3000,
        });
      }
      return this.$emit("changeTechnicianResp", {
        status: "ok",
        result: res,
      });
    },
  },
};
</script>
